import React from "react";
import img110 from "../assests/CHAIR.jpeg";
import img111 from "../assests/DEPCHAIR.jpeg";
import img112 from "../assests/SECRETARY.jpeg";
import img113 from "../assests/HUN_7763-Copy.jpg";
import img114 from "../assests/MEMBERREG.jpeg";
import img115 from "../assests/ntsiki.jpg";
import img117 from "../assests/ntonto1.jpg";
import img118 from "../assests/KIT1.jpeg";
import img119 from "../assests/qac20.jpg";
import img121 from "../assests/qac19.jpg";
import img7790 from "../assests/QIMG1.jpeg";
import img13 from "../assests/charity.jpg";
import img400 from "../assests/Thando_Mabena.jpeg";
import img401 from "../assests/P_Minnaar.jpeg";
import img402 from "../assests/Amor_Benaard.jpeg";
import img403 from "../assests/Nonosi_Mmamakoko.jpeg";
import img404 from "../assests/Sincedile_Mngese.jpeg";
import img405 from "../assests/Itumeleng_Mokua.jpeg";

const AboutUs = () => {
  return (
    <div
      name="AboutUs"
      className="w-full h-full bg-[#001ea1] text-gray-300 bg-cover grid grid-cols-1 "
    >
      <div className="pb-4 pt-32">
        <p className="text-4xl text-center font-bold  text-white">About Us</p>
        <p className="py-100 pt-4  text-1xl text-center  text-white ">
          Get to know us better
        </p>
      </div>

      <div className=" grid grid-cols-1 gap-2 contain px-5 h-full pt-2">
        {/** Grid Item */}

        <div className=" ">
          <p className="text-white span  text-1xl py-4  text-center items-center  justify-center  font-bold  tracking-wider">
            Founded on 13 November 2020 by Coach Benzi Tenza, along with
            co-founders Maria Gumede and Hulikani Nyathi, Qhubeka Athletic Club
            (QAC), affectionately known as QAC, was built on a mission to change
            the game. Based in Boksburg, Ekurhuleni, we are an inclusive club
            that believes everyone, regardless of background, age, fitness
            level, or body type, should have a space where they can thrive and
            reach their PBs.
          </p>

          <p className="text-white span  text-1xl py-4  text-center items-center  justify-center  font-bold  tracking-wider">
            Our club is more than just a place for training; it’s a platform
            where athletes can unlock their potential, embrace new challenges,
            and share in the collective success of the Qhubeka AC family.
          </p>
          <p className="text-white span  text-1xl py-4  text-center items-center  justify-center  font-bold  tracking-wider">
            Whether you're a beginner or a seasoned marathoner, we are here to
            support, motivate, and guide you in your pursuit of greatness.
          </p>
          <p className="text-white span  text-1xl py-4  text-center items-center  justify-center  font-bold  tracking-wider">
            While running is our primary discipline, we also embrace hiking and
            cycling, and we are committed to growing these areas to offer more
            opportunities for our members to challenge themselves.
          </p>
        </div>

        <div className=" w-full  rounded-2xl">
          <img
            src={img7790}
            className=" hover:scale-105  duration-1000 shadow-2xl shadow-black object-cover w-full  rounded-md  object-center justify-center  "
            alt="Welcome Image"
            loading="lazy"
          />
        </div>
      </div>

      <div className=" grid md:grid-cols-3 gap-5 pt-7 py-5 px-5">
        {/** Grid Item */}

        <div className=" bg-[#001ea1] shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto ">
          {/**Hover effect */}
          <div className="">
            <span className="px-5 py-3  items-center flex justify-center text-center font-bold first-letter text-white tracking-wider">
              Over the years, QAC has grown into a vibrant, welcoming club known
              for its camaraderie and support. We’re proud to uphold the spirit
              of running through inclusivity, hosting community-focused events,
              races, and social gatherings, all while celebrating every member’s
              achievements.
            </span>
          </div>
        </div>

        <div className=" shadow-[#0f0f0f] container rounded-xl flex justify-center items-center  ">
          <img
            src={img121}
            className=" hover:scale-110  duration-1000 shadow-2xl shadow-[#0f0f0f] object-cover w-full  rounded-md  object-center  md:h-[400px]"
            alt="Welcome Image"
            loading="lazy"
          />
        </div>

        <div className=" bg-white shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto">
          {/**Hover effect */}
          <div className="">
            <div>
              <span className="px-4 py-3 text-[#001ea1] text-center items-center flex justify-center font-bold first-letter tracking-wider">
                We’re known for painting the streets red, blue, and white,
                proudly showcasing our club colors wherever we go.
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* <div className= ' py-3 w-full  rounded-2xl' >       
             <img src={capture2} className= '  h-10  w-full  object-cover overflow-auto ' alt= 'Welcome Image' loading='lazy' />

        </div> */}
      <div className=" grid md:grid-cols-3 gap-5 pt-7 px-5">
        {/** Grid Item */}

        <div className=" bg-[#001ea1] shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto content-div">
          {/**Hover effect */}
          <div className="">
            <div className="">
              <span className="text-4xl  items-center flex justify-center font-bold first-letter text-white tracking-wider">
                Our Motto
              </span>
            </div>
            <span className="px-5 pt-5  items-center flex justify-center text-center font-bold first-letter text-white tracking-wider">
              "Level Up" is at the heart of everything we do. We believe in
              pushing boundaries, not only to elevate our performances but also
              to expand our impact in the running community. We #LevelUp in all
              that we do—from organizing our annual Qhubeka AC Human Rights Day
              Race to hosting weekly hilly LSD training runs, to our post-race
              braais—the list goes on and on.
            </span>
          </div>
        </div>

        <div className=" bg-red-700 shadow-lg shadow-[#0f0f0f] group container rounded-xl flex justify-center items-center mx-auto content-div">
          {/**Hover effect */}
          <div className="">
            <div className="">
              <span className="text-4xl  items-center flex justify-center font-bold first-letter text-white tracking-wider">
                Vision
              </span>
            </div>
            <span className="px-5 pt-5  items-center flex text-center justify-center font-bold first-letter text-white tracking-wider">
              “To bring inspiration and innovation to all our athletes.”
            </span>
          </div>
        </div>

        <div className=" bg-white shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto content-div">
          {/**Hover effect */}
          <div className="">
            <div className="">
              <span className="text-4xl text-[#001ea1] items-center flex justify-center font-bold first-letter  tracking-wider">
                Mission
              </span>
            </div>

            <div>
              <span className="px-4 pt-5 text-[#001ea1] text-center items-center flex justify-center font-bold first-letter tracking-wider">
                We are dedicated to fostering the growth and development of all
                our athletes through an inclusive approach. By embracing
                innovative ideas, we provide opportunities for every member to
                reach their optimal performance and maintain a healthy, active
                lifestyle.
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className=" py-3 px-4  w-full  rounded-2xl">
        <img
          src={img119}
          className="py-4 hover:scale-105 duration-1000 rounded-2xl shadow-lg shadow-[#0f0f0f] w-full  object-cover overflow-auto "
          alt="Welcome Image"
          loading="lazy"
        />
      </div>

      {/* <div className= ' py-3 w-full  rounded-2xl' >       
             <img src={capture2} className= ' h-10  w-full  object-cover overflow-auto ' alt= 'Welcome Image' loading='lazy' />

        </div> */}

      <div className=" px-5">
        <p className="text-4xl text-center font-bold  text-white">
          Executive Committee
        </p>
        <p className="py-100 pt-4 text-center  text-white ">
          Our Executive Committee is made up of dedicated leaders who work
          tirelessly behind the scenes to ensure that QAC runs smoothly. They
          handle all the organizational aspects of the club, from events to
          membership management and marketing.{" "}
        </p>
      </div>

      <div className=" grid md:grid-cols-3 gap-5 pt-5 w-full">
        {/** Grid Item */}

        <div className=" grid grid-cols-1">
          {/**Hover effect */}
          <div className="flex items-center justify-center ">
            <img
              src={img110}
              className="hover:scale-110 shadow-2xl shadow-black duration-1000 rounded-3xl items-center justify-center flex h-[300px] object-contain"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
          <div className=" w-full rounded-md text-center items-center justify-center grid grid-cols-1">
            <span className="  text-sm font-bold    text-white tracking-wider">
              President & Coach
            </span>
            <span className=" rounded-b-md text-sm  font-bold    text-white tracking-wider">
              Benzi Tenza
            </span>
          </div>
        </div>

        <div className="  grid grid-cols-1">
          {/**Hover effect */}
          <div className=" flex items-center justify-center  ">
            <img
              src={img111}
              className="hover:scale-110 shadow-2xl shadow-black duration-1000 rounded-3xl items-center justify-center flex h-[300px] object-contain"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
          <div className=" w-full rounded-md text-center items-center justify-center grid grid-cols-1">
            <span className="  text-sm font-bold   text-white tracking-wider">
              Chairperson
            </span>
            <span className=" rounded-b-md text-sm  font-bold   text-white tracking-wider">
              Maria Gumede
            </span>
          </div>
        </div>

        <div className=" grid grid-cols-1">
          {/**Hover effect */}
          <div className=" flex items-center justify-center  ">
            <img
              src={img112}
              className="hover:scale-110 shadow-2xl shadow-black duration-1000 rounded-3xl items-center justify-center flex h-[300px] object-contain"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
          <div className=" w-full rounded-md text-center items-center justify-center grid grid-cols-1">
            <span className="  text-sm font-bold    text-white tracking-wider">
              Secretary
            </span>
            <span className=" rounded-b-md text-sm  font-bold    text-white tracking-wider">
              Tshidi Thulo
            </span>
          </div>
        </div>

        <div className=" grid grid-cols-1">
          {/**Hover effect */}
          <div className=" flex items-center justify-center  ">
            <img
              src={img113}
              className="hover:scale-110 shadow-2xl shadow-black duration-1000 rounded-3xl items-center justify-center flex h-[300px] object-contain"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
          <div className=" w-full rounded-md text-center items-center justify-center grid grid-cols-1">
            <span className="  text-sm font-bold    text-white tracking-wider">
              Treasurer
            </span>
            <span className=" rounded-b-md text-sm  font-bold    text-white tracking-wider">
              Sithandile Meva
            </span>
          </div>
        </div>

        <div className=" grid grid-cols-1 rounded-md">
          {/**Hover effect */}
          <div className=" flex items-center justify-center  ">
            <img
              src={img400}
              className=" hover:scale-110 shadow-2xl shadow-black duration-1000 rounded-3xl items-center justify-center flex h-[300px] object-contain"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
          <div className=" w-full rounded-md text-center items-center justify-center grid grid-cols-1">
            <span className="  text-sm font-bold    text-white tracking-wider">
              Registration Officer
            </span>
            <span className=" rounded-b-md text-sm  font-bold    text-white tracking-wider">
              Thando Mabena
            </span>
          </div>
        </div>

        <div className=" grid grid-cols-1">
          {/**Hover effect */}
          <div className=" flex items-center justify-center  ">
            <img
              src={img401}
              className="hover:scale-110 shadow-2xl shadow-black duration-1000 rounded-3xl items-center justify-center flex h-[300px] object-contain"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
          <div className=" w-full rounded-md text-center items-center justify-center grid grid-cols-1">
            <span className="  text-sm font-bold    text-white tracking-wider">
              Marketing & Communication Officer
            </span>
            <span className=" rounded-b-md text-sm  font-bold    text-white tracking-wider">
              P Minnaar
            </span>
          </div>
        </div>
        <div className=" grid grid-cols-1">
          {/**Hover effect */}
          <div className=" flex items-center justify-center  ">
            <img
              src={img402}
              className="hover:scale-110 shadow-2xl shadow-black duration-1000 rounded-3xl items-center justify-center flex h-[300px] object-contain"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
          <div className=" w-full rounded-md text-center items-center justify-center grid grid-cols-1">
            <span className="  text-sm font-bold    text-white tracking-wider">
              Club Kit Co-ordinator
            </span>
            <span className=" rounded-b-md text-sm  font-bold    text-white tracking-wider">
              Amor Benaard
            </span>
          </div>
        </div>

        <div className=" grid grid-cols-1">
          {/**Hover effect */}
          <div className=" flex items-center justify-center  ">
            <img
              src={img403}
              className="hover:scale-110 shadow-2xl shadow-black duration-1000 rounded-3xl items-center justify-center flex h-[300px] object-contain"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
          <div className=" pb-6 w-full rounded-md text-center items-center justify-center grid grid-cols-1">
            <span className="  text-sm font-bold    text-white tracking-wider">
              Hiking Captain
            </span>
            <span className=" rounded-b-md text-sm  font-bold    text-white tracking-wider">
              Nonosi Mmamakoko
            </span>
          </div>
        </div>

      {/**  <div className=" grid grid-cols-1">
          Hover effect 
          <div className=" flex items-center justify-center  ">
            <img
              src={img404}
              className="hover:scale-110 shadow-2xl shadow-black duration-1000 rounded-3xl items-center justify-center flex h-[300px] object-contain"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
          <div className=" pb-6 w-full rounded-md text-center items-center justify-center grid grid-cols-1">
            <span className="  text-sm font-bold    text-white tracking-wider">
              Road Running Captain & Cross Country Captain
            </span>
            <span className=" rounded-b-md text-sm  font-bold    text-white tracking-wider">
              Sincedile Mngese
            </span>
          </div>
        </div>*/}
        <div className=" grid grid-cols-1">
          {/**Hover effect */}
          <div className=" flex items-center justify-center  ">
            <img
              src={img405}
              className="hover:scale-110 shadow-2xl shadow-black duration-1000 rounded-3xl items-center justify-center flex h-[300px] object-contain"
              alt="Welcome Image"
              loading="lazy"
            />
          </div>
          <div className=" pb-6 w-full rounded-md text-center items-center justify-center grid grid-cols-1">
            <span className="  text-sm font-bold    text-white tracking-wider">
              Social & Event Co-ordinator
            </span>
            <span className=" rounded-b-md text-sm  font-bold    text-white tracking-wider">
              Itumeleng Mokua
            </span>
          </div>
        </div>
        <div />

        {/* <div style={{backgroundImage: `url(${Runner})`}} className='  shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/**Hover effect 
                    <div className='opacity-0 group-hover:opacity-75'> 
                        <span className='text-2xl font-bold text-white tracking-wider'>
                            Beginner Training
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className='text-center rounded-lg px-6 py-3 m-2 bg-white'> Read More</button>
                                </a>

                        </div>
                    </div>
                    

                </div>   
                <div style={{backgroundImage: `url(${Runner})`}} className=' shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/**Hover effect 
                    <div className='opacity-0 group-hover:opacity-75'> 
                        <span className='text-2xl font-bold text-white tracking-wider'>
                            Elite Training
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className='text-center rounded-lg px-6 py-3 m-2 bg-white'> Read More</button>
                                </a>

                        </div>
                    </div>
                    

                </div>  
                <div style={{backgroundImage: `url(${Runner})`}} className=' shadow-lg shadow-[#0f0f0f] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/**Hover effect 
                    <div className='opacity-0 group-hover:opacity-75'> 
                        <span className='text-2xl font-bold text-white tracking-wider'>
                            Elite Training
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className='text-center rounded-lg px-6 py-3 m-2 bg-white'> Read More</button>
                                </a>

                        </div>
                    </div>
                    

                </div>      */}
      </div>
    </div>
  );
};

export default AboutUs;
